











































































import BaseComponent from '@/components/BaseComponent';
import SendConfirm from '@/components/SendConfirm.vue';
import { Component, Prop } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import { groupMailMdl } from '@/models/groupMailMdl';

@Component({
    components: { SendConfirm },
})
export default class GroupMail extends BaseComponent {
    // @Prop({ default: false }) private is_display!: boolean;
    @Prop({ default: '' }) private group_name!: string;
    @Prop({ default: -1 }) private group_id!: number;
    private is_display: boolean = true;
    private mailData: groupMailMdl[] = [];
    private sendConfirmFlg: boolean = false; // テストメール送信確認ダイアログ
    private sendMailAddress: string = '';
    // ヘッダー情報
    private mailDataHeader: any = [
        { text: 'メールアドレス', align: 'center', value: 'mail_address', sortable: false },
        { text: '送信有無', align: 'center', value: 'mail_send_flg', sortable: false, width: 100 },
        { text: '削除', align: 'center', value: 'delete', sortable: false, width: 80 },
    ];

    created() {
        this.getMailData();
    }
    private closeDialog(v: boolean) {
        this.$emit('closeDialog', v);
    }
    // グループメールデータ取得
    private async getMailData() {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            let params: any = { group_id: this.group_id };
            const resp: AxiosResponse<any> = await this.$http.post('group_mail_list.php', params, {
                headers: { token: this.token },
            });
            switch (resp.data.result) {
                case 'SUCCESS':
                    this.mailData = resp.data.items.map(function(v: any) {
                        return new groupMailMdl(groupMailMdl.toJsonDataOnModel(v));
                    });
                    break;
                case 'VALIDATION_ERROR':
                    // バリデーションエラーメッセージをセット
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: resp.data.errors,
                        return_flg: true,
                    });
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'PARAM_ERROR':
                case 'AUTHORITY_ERROR':
                case 'DBCONNECTION_ERROR':
                case 'DATA_NOTFOUND_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ取得失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'データ取得失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }
    // メールアドレス入力欄を追加
    private onClickMailAdd() {
        this.mailData.push(new groupMailMdl());
    }
    private onClickDeleteRow(v: any) {
        let selected = this.mailData.indexOf(v);
        this.mailData.splice(selected, 1);
    }
    private async onClickConfirm() {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);
            let params = { group_id: this.group_id, mail: this.mailData };
            const resp: AxiosResponse<any> = await this.$http.post('group_mail_edit.php', params, {
                headers: { token: this.token },
            });

            switch (resp.data.result) {
                case 'SUCCESS':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'success',
                        timeout: 5000,
                        message: 'データ登録完了',
                        return_flg: false,
                    });
                    this.$emit('closeDialog', true);
                    break;
                case 'VALIDATION_ERROR':
                    // バリデーションエラーメッセージをセット
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'メールアドレス登録失敗-' + resp.data.errors.mail,
                        return_flg: false,
                    });
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'SAVE_FAILED_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'メールアドレス登録失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'メールアドレス登録失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }
    private sendMessage(v: any) {
        let selected = this.mailData.indexOf(v);
        this.sendConfirmFlg = true;
        this.sendMailAddress = this.mailData[selected].mail_address;
    }
    // 削除確認ダイアログクローズ
    private closeSendDialog(value: boolean) {
        this.sendConfirmFlg = false;
        if (value) {
            this.sendTestMail();
        }
    }
    private async sendTestMail() {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            let params: any = { sendmail: this.sendMailAddress };
            const resp: AxiosResponse<any> = await this.$http.post('send_testmail.php', params, {
                headers: { token: this.token },
            });
            switch (resp.data.result) {
                case 'SUCCESS':
                    alert('テストメールを送信しました。');
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'PARAM_ERROR':
                case 'AUTHORITY_ERROR':
                case 'DBCONNECTION_ERROR':
                case 'DATA_NOTFOUND_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'メール送信失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'メール送信失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }
}
